<div class="layout-breadcrumb">
    <div class="breadcrumb">
        <div class="route-bar-breadcrumb">
                <ng-template ngFor let-item let-last="last" [ngForOf]="items">
                    <li>
                        <a [routerLink]="item?.routerLink" *ngIf="item?.routerLink">{{item?.label}}</a>
                        <ng-container *ngIf="!item?.routerLink">{{item?.label}}</ng-container>
                    </li>
                    <li *ngIf="!last"><i class="pi pi-angle-right"></i></li>
                </ng-template>
        </div>
    </div>

    <div *ngIf="!appMain?.esProduccion" class="notification">👋 Sistema no activado con sunat, comuníquese con el administrador.</div>
    <div class="breadcrumb-actions">
        <app-notification-indicator></app-notification-indicator>
        <app-network-indicator></app-network-indicator>
    </div>
</div>
